import { useMediaQuery } from "beautiful-react-hooks";

export const useIsSmallDevice = () => {
  return useMediaQuery("(max-width: 1000px)");
};
